import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Stack,
  TextField,
  Typography,
  Zoom,
} from "@mui/material";
import { useFormik } from "formik";
import { useState } from "react";
import * as Yup from "yup";

function CreateContact(props) {
  // const{contacts, upDate} = useContext(contactContext)

  const { handleSave } = props;
  //show more contact fields
  const [more, setMore] = useState("none");
  //change btn name from more to less
  const [btnName, setBtnName] = useState("show more");

  const myFormik = useFormik({
    initialValues: {
      userName: "",
      firstName: "",
      middleName: "",
      lastName: "",
      nickName: "",
      email: "",
      primaryPhone: "",
      secondaryPhone: "",
      company: "",
      title: "",
      street: "",
      PoBox: "",
      City: "",
      county: "",
      website: "",
      birthday: new Date().toLocaleDateString(),
      label: "",
      edit: false,
    },

    validationSchema: Yup.object({
      userName: Yup.string()
        .required("Required")
        .min(3, "must be more than 3 characters"),
      firstName: Yup.string()
        .required("Required")
        .min(3, "must be more than 3 characters"),
      middleName: Yup.string().min(3, "must be more than 3 characters"),
      lastName: Yup.string()
        .required("Required")
        .min(3, "must be more than 3 characters"),
      email: Yup.string()
        .email()
        .required("required")
        .matches(/^[a-z].+@./, "Invalid email"),
      primaryPhone: Yup.string()
        .required("Required")
        .min(10, "Invalid phone number")
        .max(13, "Invalid phone number")
        .matches(/^[0+]/, "Invalid phone number"),
      secondaryPhone: Yup.string()
        .min(10, "Invalid phone number")
        .max(13, "Invalid phone number")
        .matches(/^[0+]/, "Invalid phone number"),
    }),

    onSubmit: (values) => {
      console.log(JSON.stringify(values, null, 2));
      handleSave(values);
    },
  });

  //handle show more
  const handleShowMore = () => {
    const moreVal = more === "none" ? "flex" : "none";
    const newBtnName = btnName === "show more" ? "show less" : "show more";
    setMore(moreVal);
    setBtnName(newBtnName);
  };

  return (
    <>
    <Zoom in={true} style={{ transitionDelay: "200ms" }}>
      <Card elevation={2}>
        <CardHeader title="New Contact" />
        <CardContent>
          <form onSubmit={myFormik.handleSubmit}>
            <Box my={1}>
              <Stack>
                <TextField
                  size="small"
                  required
                  label="Username"
                  id="userName"
                  name="userName"
                  value={myFormik.values.userName}
                  onChange={myFormik.handleChange}
                  onBlur={myFormik.handleBlur}
                />
                {myFormik.errors.userName && myFormik.touched.userName ? (
                  <Typography color="error">
                    {myFormik.errors.userName}
                  </Typography>
                ) : null}
              </Stack>
            </Box>
            <Box display="flex" columnGap={2}>
              <Stack>
                <TextField
                  size="small"
                  required
                  label="First Name"
                  id="firstName"
                  name="firstName"
                  value={myFormik.values.firstName}
                  onChange={myFormik.handleChange}
                  onBlur={myFormik.handleBlur}
                />
                {myFormik.errors.firstName && myFormik.touched.firstName ? (
                  <Typography color="error">
                    {myFormik.errors.firstName}
                  </Typography>
                ) : null}
              </Stack>

              <Stack>
                <TextField
                  size="small"
                  label="Middle Name"
                  id="middleName"
                  name="middleName"
                  value={myFormik.values.middleName}
                  onChange={myFormik.handleChange}
                  onBlur={myFormik.handleBlur}
                />
                {myFormik.errors.middleName && myFormik.touched.middleName ? (
                  <Typography color="error">
                    {myFormik.errors.middleName}
                  </Typography>
                ) : null}
              </Stack>
              <Stack>
                <TextField
                  size="small"
                  required
                  label="Last Name"
                  id="lastName"
                  name="lastName"
                  value={myFormik.values.lastName}
                  onChange={myFormik.handleChange}
                  onBlur={myFormik.handleBlur}
                />
                {myFormik.errors.lastName && myFormik.touched.lastName ? (
                  <Typography color="error">
                    {myFormik.errors.lastName}
                  </Typography>
                ) : null}
              </Stack>

              <TextField
                size="small"
                label="Nickname"
                id="nickName"
                name="nickName"
                value={myFormik.values.nickName}
                onChange={myFormik.handleChange}
                onBlur={myFormik.handleBlur}
              />
            </Box>
            <Box display="flex" columnGap={2} mt={1}>
              <Stack>
                <TextField
                  size="small"
                  required
                  id="email"
                  name="email"
                  label="email"
                  value={myFormik.values.email}
                  onChange={myFormik.handleChange}
                  onBlur={myFormik.handleBlur}
                />
                {myFormik.errors.email && myFormik.touched.email ? (
                  <Typography color="error">{myFormik.errors.email}</Typography>
                ) : null}
              </Stack>

              <Stack>
                <TextField
                  size="small"
                  required
                  id="primaryPhone"
                  name="primaryPhone"
                  label="Mobile"
                  value={myFormik.values.primaryPhone}
                  onChange={myFormik.handleChange}
                  onBlur={myFormik.handleBlur}
                />
                {myFormik.errors.primaryPhone &&
                myFormik.touched.primaryPhone ? (
                  <Typography color="error">
                    {myFormik.errors.primaryPhone}
                  </Typography>
                ) : null}
              </Stack>
              <Stack>
                <TextField
                  size="small"
                  id="secondaryPhone"
                  name="secondaryPhone"
                  label="Office Phone"
                  value={myFormik.values.secondaryPhone}
                  onChange={myFormik.handleChange}
                  onBlur={myFormik.handleBlur}
                />

                {myFormik.errors.secondaryPhone &&
                myFormik.touched.secondaryPhone ? (
                  <Typography color="error">
                    {myFormik.errors.secondaryPhone}
                  </Typography>
                ) : null}
              </Stack>

              <TextField
                size="small"
                id="company"
                name="company"
                label="Company"
                value={myFormik.values.company}
                onChange={myFormik.handleChange}
                onBlur={myFormik.handleBlur}
              />
            </Box>
            <Stack display={more} mt={2}>
              <Typography>More Fields</Typography>
              <Divider />
              <Box display="flex" columnGap={2} mt={1}>
                <TextField
                  size="small"
                  label="Title"
                  id="title"
                  name="title"
                  value={myFormik.values.title}
                  onChange={myFormik.handleChange}
                  onBlur={myFormik.handleBlur}
                />

                <TextField
                  size="small"
                  label="Street"
                  id="street"
                  name="street"
                  value={myFormik.values.street}
                  onChange={myFormik.handleChange}
                  onBlur={myFormik.handleBlur}
                />

                <TextField
                  size="small"
                  label="PO Box"
                  id="PoBox"
                  name="PoBox"
                  value={myFormik.values.PoBox}
                  onChange={myFormik.handleChange}
                  onBlur={myFormik.handleBlur}
                />

                <TextField
                  size="small"
                  label="City"
                  id="city"
                  name="city"
                  value={myFormik.values.city}
                  onChange={myFormik.handleChange}
                  onBlur={myFormik.handleBlur}
                />
              </Box>
              <Box display="flex" columnGap={2} mt={1}>
                <TextField
                  size="small"
                  label="County"
                  id="county"
                  name="county"
                  value={myFormik.values.county}
                  onChange={myFormik.handleChange}
                  onBlur={myFormik.handleBlur}
                />

                <TextField
                  size="small"
                  label="Website"
                  id="website"
                  name="website"
                  value={myFormik.values.website}
                  onChange={myFormik.handleChange}
                  onBlur={myFormik.handleBlur}
                />

                <TextField
                  size="small"
                  label="Birthday"
                  id="birthday"
                  name="birthday"
                  value={myFormik.values.birthday}
                  onChange={myFormik.handleChange}
                  onBlur={myFormik.handleBlur}
                />

                <TextField
                  size="small"
                  label="Group"
                  id="label"
                  name="label"
                  value={myFormik.values.label}
                  onChange={myFormik.handleChange}
                  onBlur={myFormik.handleBlur}
                />
              </Box>
            </Stack>
            <Box display={"flex"}>
              <Button onClick={handleShowMore}>{btnName}</Button>
              <Button type="submit" sx={{ ml: "auto" }}>
                Save
              </Button>
            </Box>
          </form>
        </CardContent>
      </Card>
      </Zoom>
    </>
  );
}

export default CreateContact;
